export default __webpack_public_path__ + "images/amazon_logo.png";